
import { TranslateService } from '@ngx-translate/core';
import { PagerService } from './pager.service';
import { Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.css']
})
export class PagerComponent implements OnInit, OnChanges, DoCheck {
  @Input() items: any[];
  @Input() pageSize = 10;
  @Input() totalItemsCount = 0;
  @Output() onPageChanged = new EventEmitter<any>();
  // pager object
  pager: any = {};
  pages: any[];
  pagedItems: any[];
  currentPage;
  currentLang: string;

  constructor(private pagerService: PagerService,
    public translate?: TranslateService
  ) {

  }

  changePageSize(e) {
    this.pageSize = e.target["value"];
    this.changePage(1);
  }

  ngDoCheck() {
    this.currentLang = this.currentLang ?? this.translate?.currentLang;
  }

  ngOnInit() {
    this.currentPage = 1;
    this.pages = [];
    //this.changePage(1);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pager = this.pagerService.getPager(this.totalItemsCount, this.currentPage, this.pageSize);
    if (changes?.['totalItemsCount']) {
      this.currentPage = 1;
    }
  }

  changePage(page) {
    this.currentPage = page;
    if (!this.items || this.items.length === 0) {
      this.onPageChanged.emit({ page: [], pageSize: 10 });
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.totalItemsCount, this.currentPage, this.pageSize);
    // get current page of items
    this.pagedItems = this.items;

    this.onPageChanged.emit({ pageNumber: page, pageSize: this.pageSize } );
  }

  last() {
    this.changePage(this.pager.totalPages);
  }

  next() {
    this.changePage(this.currentPage + 1);
  }

  previous() {
    this.changePage(this.currentPage - 1);
  }

  first() {
    this.currentPage = 1;
    this.changePage(this.currentPage);
  }
}
